import type { Language } from './schemas/simulation'

/**
 * '어떻게 알고 오셨어요?' 한 문항 (선택, C56 — PR #18 옮김). 앱의 첫 결과 카드와 견적 요청서가 같은 값을 쓰고,
 * 견적 요청서의 답은 관리자 견적 상세에 보인다. AI 답변(ChatGPT 등)을 보고 온 사람이 '검색'이나 '기타'에 묻히지 않게 따로 둔다.
 * 앱에 보일지는 GET /config 의 features.heardFrom(서버 코드)과 settings.heardFromSurvey.enabled(관리자, 기본 꺼짐) 두 겹이다
 */
export const HEARD_FROM_SOURCES = [
  'ai_answer',
  'search',
  'social',
  'referral',
  'event_email',
  'other',
] as const
export type HeardFrom = (typeof HEARD_FROM_SOURCES)[number]

/** 보기 이름. 앱(4개 언어)과 관리자(ko)가 같이 쓴다 */
export const HEARD_FROM_LABELS: Record<Language, Record<HeardFrom, string>> = {
  en: {
    ai_answer: 'AI answer (ChatGPT etc.)',
    search: 'Search',
    social: 'Social media',
    referral: 'Friend or colleague',
    event_email: 'Event or email',
    other: 'Other',
  },
  ko: {
    ai_answer: 'AI 답변 (ChatGPT 등)',
    search: '검색',
    social: 'SNS',
    referral: '지인 추천',
    event_email: '행사 또는 메일',
    other: '기타',
  },
  ja: {
    ai_answer: 'AIの回答（ChatGPTなど）',
    search: '検索',
    social: 'SNS',
    referral: '知人の紹介',
    event_email: 'イベントやメール',
    other: 'その他',
  },
  zh: {
    ai_answer: 'AI 回答（ChatGPT 等）',
    search: '搜索',
    social: '社交媒体',
    referral: '朋友推荐',
    event_email: '活动或邮件',
    other: '其他',
  },
}
